import { DefaultError, QueryClient, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

export interface DocumentDetailsResponse {
  id: number;
  title: string;
  field_common_malay_title: string;
  field_common_mandarin_title: string;
  body: string;
  field_common_malay_description: string;
  field_common_mandarin_descriptio?: string;
  field_common_image: string;
  field_store_location: string;
  field_created_date?: string;
  field_updated_date?: string;
  field_products_published?: string;
  createdAt: string;
  updatedAt: string;
  status: boolean;
}

const fetchAllExpressData = async (id: string): Promise<DocumentDetailsResponse[]> => {
  // console.log("Calling API: /api/all-e-xpress-data-list");
  const response = await eramanCMSApi.get(`/api/all-e-xpress-data-list`);
  console.log("API Response:", response.data.data?.[0]); // Full API response
  return response.data.data || [];
};

const useAllExpressDocuments = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse[], DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse[], DefaultError> => {
  return useQuery<DocumentDetailsResponse[], DefaultError>(
    {
      queryKey: ["allExpressDocuments", id],
      enabled: !!id,
      queryFn: () => {
        return fetchAllExpressData(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useAllExpressDocuments };
